import {
  apiRequest,
  anakDetail,
  anakUpdate,
  masterRegion,
  masterParents,
  masterRelationshipStatus,
  masterMaritalStatus,
  masterGajiwebSatker,
  anakUpdateFile,
  fileTemplate,
} from "../../../../../../services/adapters/kepegawaian/anakService";

class UpdateRepository {
  fetchMaritalStatus = async (query) => {
    return await apiRequest(
      "get",
      masterMaritalStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchRelationshipStatus = async (query) => {
    return await apiRequest(
      "get",
      masterRelationshipStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCountry = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchParents = async (query) => {
    return await apiRequest(
      "get",
      masterParents,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      anakDetail,
      {
        params: query,
      },
      true
    );
  };
  fetchFileTemplate = async (query) => {
    return await apiRequest(
      "get",
      fileTemplate,
      {
        params: query,
      },
      true
    );
  };

  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      anakUpdate,
      {
        body: query,
      },
      true
    );
  };
  fetchUpdateFile = async (query) => {
    return await apiRequest(
      "post",
      anakUpdateFile,
      {
        body: query,
      },
      true
    );
  };

  fetchSatkerGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebSatker,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
